import { render } from "./ModalImagePreview.vue?vue&type=template&id=2cc45abc&scoped=true"
import script from "./ModalImagePreview.vue?vue&type=script&lang=js"
export * from "./ModalImagePreview.vue?vue&type=script&lang=js"

import "./ModalImagePreview.vue?vue&type=style&index=0&id=2cc45abc&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc45abc"]])

export default __exports__